import React from 'react'
import { useAtom, useAtomValue } from 'jotai'
import logo from '@assets/logoCrediper_20Anni.svg'
import logo_mobile from '@assets/logoMobile.svg'
import eye from '@assets/eye.svg'
import { ProvenienzaMap, showSubStepAtom } from '@store/store'
import CloseIcon from '@ui/components/svg/ico_x'
import { IconBase } from '@ui/components/svg/IconBase'
//import ModalRoot from '@ui/components/ModalRoot'
//import { _useSaveDataForm } from './simulatore-hooks'

import { StepsRichiesta } from '@store/stepsRichiesta'
import {
	currentStepAtom,
	documentFlowVariantAtom,
	selectedSubStepAtom,
	selectedValueAtom,
} from '@store/atoms'

import {
	activeDocumentAtom,
	//activeSubStepIdAtom,
	anagraficaSubStepAtom,
	//contactReturnPointAtom,
	//currentSideAtom,
	//documentModeAtom,
	documentNextAtom,
	//documentSubStepIndexAtom,
	infoStructAtom,
	lastContactSubStepAtom,
	lastServicesSubStepAtom,
	insuranceRemovedPageAtom,
	professionSubStepAtom,
} from './stepper/data/store'

import { DocumentMode, type SubStepContact } from './stepper/data/steps'
import { ExitModalForm } from './ExitModalForm'
import type { Step } from '@store/reducer'
import { useAppContext } from '@hooks/use-app-context'
import { OffertaPreview } from './OffertaPreviewModal'
import { getAgeFromBirthDate } from '@utils/dates'
import { affinityLogoAtom } from '@store/store'
import { useAffinityLogo } from '@hooks/useAffinityLogo'

const Header = ({
	onBack: onBackOverride,
	hideNav,
	hideClose,
	hideBack,
}: { onBack?: () => void; hideNav?: boolean; hideClose?: boolean; hideBack?:boolean } = {}) => {
	const { state } = useAppContext()
	const codiceAffinity = state.token?.StartingValues?.CodiceAffinity || state.data?.StartingValues?.CodiceAffinity
	const [affinityLogo] = useAtom(affinityLogoAtom)
	const { fetchLogo } = useAffinityLogo()

	// On mount, if a CodiceAffinity is already present, fetch its logo.
	React.useEffect(() => {
		if (codiceAffinity && !affinityLogo) {
			fetchLogo(codiceAffinity)
		}
	}, [codiceAffinity]) // affinityLogo intentionally excluded to avoid re-fetch loop

	const [infoStruct] = useAtom(infoStructAtom)
	const [activeStep, setActiveStep] = useAtom(currentStepAtom)

	const [selectedSubStep, setSelectedSubStep] = useAtom(selectedSubStepAtom)
	const [showSubStepMap] = useAtom(showSubStepAtom)
	const showSubStep = showSubStepMap[activeStep] ?? false
	const [selectedValueMap, setSelectedValueMap] = useAtom(selectedValueAtom)

	const documentFlowVariant = useAtomValue(documentFlowVariantAtom) //da mobilw QRCODE

		
		console.log("HEADER",documentFlowVariant)
	const [activeDocument] = useAtom(activeDocumentAtom)
	//const [activeSubStepId] = useAtom(activeSubStepIdAtom)

	//const [returnPoint, setReturnPoint] = useAtom(contactReturnPointAtom)

	const [, setDocumentNext] = useAtom(documentNextAtom) ///navigazione wizard

	///-----------------HIDE BACK BUTTON
const hideBackButton =
	hideBack ||
	documentFlowVariant === 'mobileQr' &&
	activeStep === StepsRichiesta.CONTATTI &&
	(
		(selectedSubStep === 'selectDocument' && !activeDocument) ||
		selectedSubStep === 'contactData'
	)

	///STEP DATI ANAGRAFICI
	const [anagraficaSubStepIndex, setAnagraficaSubStepIndex] = useAtom(
		anagraficaSubStepAtom
	)
	////------------------------

	// STEP PROFESSIONE
	const [professionSubStepIndex, setProfessionSubStepIndex] = useAtom(
		professionSubStepAtom
	)
	////------------------------

	// Modale
	const [isModalOpen, setIsModalOpen] = React.useState(false)
	const [isOpenOfferta, setOpenOfferta] = React.useState(false)

	//modal
	const closeModal = () => setIsModalOpen(false)
	const openModal = () => setIsModalOpen(true)

	const closeOfferta = () => setOpenOfferta(false)
	const openOfferta = () => setOpenOfferta(true)

	//const [, setShowModal] = React.useState(false)
	//const [email, setEmail] = React.useState('')
	//const [emailError, setEmailError] = React.useState('')

	const [lastContactSubStep] = useAtom(lastContactSubStepAtom)
	const [lastServicesSubStep] = useAtom(lastServicesSubStepAtom)
	const [, setInsuranceRemovedPage] = useAtom(insuranceRemovedPageAtom)

	const handleBack = () => {
		// ===== MINI-WIZARD DOCUMENTO =====
		if (activeDocument) {
			setDocumentNext((n) => n - 1)
			return
		}

		// ===== PROFESSIONE (substeps 0..1) =====
		if (activeStep === StepsRichiesta.PROFESSIONE) {
			if (professionSubStepIndex > 0) {
				setProfessionSubStepIndex((p) => p - 1)
				return
			}
			// first sub-step → go to previous macro step
			if (activeStep > 0) setActiveStep(activeStep - 1)
			return
		}

		// ===== ANAGRAFICA (substeps 0..2) =====

	 	if (activeStep === StepsRichiesta.DATI_ANAGRAFICI) {
			if (anagraficaSubStepIndex > 0) {
				setAnagraficaSubStepIndex((p) => p - 1)
				return
			}

			// se sono al primo substep, torno allo step macro precedente
			const prevStep = activeStep - 1

			// se sto tornando a CONTATTI, rientra nel form (contactData) invece che nella selectDocument

			if (prevStep === StepsRichiesta.CONTATTI) { //per MOBIL QR ANCEH QUI NN DEVE TORNARE OLTRE CONTACT DATA
	if (documentFlowVariant === 'mobileQr') {
		setSelectedSubStep('contactData')
	} else if (lastContactSubStep) {
		setSelectedSubStep(lastContactSubStep)
	} else {
		setSelectedSubStep(null)
	}
} else {
	setSelectedSubStep(null)
}
		/* 	if (prevStep === StepsRichiesta.CONTATTI && lastContactSubStep) {
				setSelectedSubStep(lastContactSubStep) // es: 'contactData'
			} else {
				setSelectedSubStep(null)
			}
 */
			if (activeStep > 0) setActiveStep(prevStep)
			return
		} 

		// ===== RIEPILOGO → back to SERVIZI: restore last services substep =====
		if (activeStep === StepsRichiesta.RIEPILOGO) {
			// Over-70 users with no insurance and identinet disabled are auto-forwarded
			// past SERVIZI. Going back must skip SERVIZI too — otherwise the redirect
			// effect in Services fires again and creates an infinite loop.
			const userAge = getAgeFromBirthDate(state.data.Two.BirthDate)
			const isOver70 = userAge !== null && userAge >= 70
			const hasInsurance = state.data.One.Insurance
			if (isOver70 && !hasInsurance && !state.data.One.IdentinetEnabled) {
				setSelectedSubStep(null)
				setActiveStep(StepsRichiesta.PROFESSIONE)
				return
			}
			if (lastServicesSubStep) {
				setSelectedSubStep(lastServicesSubStep)
			} else {
				setSelectedSubStep(null)
			}
			setActiveStep(activeStep - 1)
			return
		}

		/**
		 * Servizi facoltativi step (4) con logica di substep
		 */
		if (activeStep === StepsRichiesta.SERVIZI_FACOLTATIVI) {
			// If we're inside any substep, go back to the main service view (InsuranceSelection)
			// or to the previous substep — regardless of whether an option is selected.
			if (selectedSubStep) {
				// Over-70 users skip insurance entirely and land directly on identinetStep.
				// Pressing back from identinetStep should take them to the previous macro step
				// (PROFESSIONE), not set selectedSubStep to null which would re-trigger the
				// redirect effect and create an infinite loop.
				const userAge = getAgeFromBirthDate(state.data.Two.BirthDate)
				const isOver70 = userAge !== null && userAge >= 70
				const hasInsurance = state.data.One.Insurance
				if (isOver70 && !hasInsurance && selectedSubStep === 'identinetStep') {
					setSelectedSubStep(null)
					setInsuranceRemovedPage(false)
					if (activeStep > 0) setActiveStep(activeStep - 1)
					return
				}
				const selectedValue = selectedValueMap[activeStep]
				const option = infoStruct.services.find(
					(o) => o.value === selectedValue
				)
				const subSteps = option?.subSteps ?? []
				const idx = subSteps.findIndex(
					(s: SubStepContact) => s.value === selectedSubStep
				)
				if (idx > 0) {
					setSelectedSubStep(subSteps[idx - 1].value)
					return
				}
				// First substep (or substep without a config match) → back to main service view
				setSelectedSubStep(null)
				return
			}
			// No substep → go back to previous macro step, clear the removed-page flag
			setInsuranceRemovedPage(false)
			if (activeStep > 0) setActiveStep(activeStep - 1)
			return
		}

		// ===== CONTACT mobileQr: blocca ritorno alla pagina radio iniziale =====
if (
	activeStep === StepsRichiesta.CONTATTI &&
	documentFlowVariant === 'mobileQr'
) {
	if (selectedSubStep === 'contactData') {
		setSelectedSubStep('mobileChoice')
		return
	}

	if (selectedSubStep === 'mobileChoice') {
		setSelectedSubStep('selectDocument')
		return
	}

	if (selectedSubStep == null) {
		setSelectedSubStep('selectDocument') //verifica dove vogliamo andare 
	}
}

		// ===== CONTACT (step 1) fallback logic =====

	


		const selectedValue = selectedValueMap[activeStep] as
			| DocumentMode
			| undefined
		const option = infoStruct.contact.find((o) => o.value === selectedValue)
		const cfgSubSteps = option?.subSteps ?? []

		// CASO SPECIALE: ingresso diretto da simulatore su contactData
		if (
			activeStep === StepsRichiesta.CONTATTI &&
			selectedSubStep === 'contactData' &&
			state.data.Provenienza === ProvenienzaMap.COMPARATORE
		) {
			setSelectedSubStep(null)
			setSelectedValueMap((prev) => ({
				...prev,
				[StepsRichiesta.CONTATTI]: '',
			}))
			setActiveStep(0 as Step)
			return
		}

		// 1) costruisco una sequenza "virtuale" di substep (stringhe)
		//    includendo quelli interni che NON sono in infoStruct
		let virtualOrder: string[] = []

		// Caso "Allega documenti" (value === '2'): prima la lista documenti, poi i documenti veri
		if (selectedValue === DocumentMode.ALLEGA) {
			virtualOrder = ['selectDocument', ...cfgSubSteps.map((s) => s.value)]
		} else {
			// altri casi: usa i substeps del config (es: contactData)
			virtualOrder = cfgSubSteps.map((s) => s.value)
		}

		// 2) se sono dentro un substep, torno indietro nel virtualOrder
		if (selectedSubStep && virtualOrder.length > 0) {
			const idx = virtualOrder.indexOf(selectedSubStep)

			// se non lo trova, torno alla pagina "padre" dello step (radio)
			if (idx === -1) {
				setSelectedSubStep(null)
				return
			}

			// se non è il primo, vai al precedente
			if (idx > 0) {
				setSelectedSubStep(virtualOrder[idx - 1])
				return
			}

			// se è il primo, esci dai substep (torni alla pagina radio)
			setSelectedSubStep(null)
			return
		}

		// 3) se non sono in un substep: macro step precedente
		if (activeStep > 0) setActiveStep(activeStep - 1)
	}


	const showHeaderNav =
		!hideNav &&
		(onBackOverride || activeStep > StepsRichiesta.LANDING || showSubStep)

	const isLanding = activeStep === StepsRichiesta.LANDING

	return (
		<header className='sticky top-0 z-50 bg-white border-t border-t-(--border-top)'>
			<div className='flex-1 max-w-[1296px] mx-auto px-3 md:px-6'>
				<div className='flex justify-between items-center py-2 '>
					<div className='flex items-center gap-3'>
						<img
							src={logo_mobile}
							alt='logo mobile'
							className='block md:hidden'
						/>
						<img src={logo} alt='logo desktop' className='hidden md:block' />
						{codiceAffinity && affinityLogo && (
							<>
								<span className='text-(--border-top) font-light text-xl'>
									|
								</span>
								<img
									src={affinityLogo}
									alt='logo affinity'
									className='h-6 md:h-8 w-auto object-contain'
								/>
							</>
						)}
					</div>
					{!hideClose && (
						<div onClick={openModal}>
							<button
								className='
					group
					w-6 h-6 md:w-8 md:h-8
					border-[1.6px] md:border-[3.5px] 
					border-(--green-default)
    cursor-pointer
    flex items-center justify-center
    rounded-full
	text-base md:text-lg
    text-(--green-default)
    hover:bg-(--green-default)
    hover:text-white
  						'
							>
								<CloseIcon className='transition-transform duration-300' />
							</button>
						</div>
					)}
				</div>

				<div
					className={`
		border-t border-t-(--border-top)
		flex items-center justify-between
		${
			!showHeaderNav
				? 'h-0 py-0'
				: 'h-[45px] md:h-[57px] md:pt-4 md:pb-0 md:px-2 py-2.5'
		}
	`}
				>
					{showHeaderNav && (
						<>
							{!hideBackButton && (
								<button
									className='group w-6 h-6 md:w-8 md:h-8 shrink-0 flex items-center justify-center rounded-full border-2 border-(--green-default) bg-linear-to-r from-(--green-default) to-(--green-hover) text-white transition-all duration-300 hover:from-white hover:to-white hover:text-(--green-default)'
									onClick={onBackOverride ?? handleBack}
								>
									<IconBase
										className='transition-transform duration-300'
										icon='M14 6L8 12L14 18'
									/>
								</button>
							)}

							<button
								type='button'
								onClick={openOfferta}
								className='underline underline-offset-4 cursor-pointer font-semibold text-(--green-default) hover:text-(--brand-green) transition inline-flex items-center gap-2 ml-auto'
							>
								Visualizza la tua richiesta
								<img src={eye} alt='' />
							</button>
						</>
					)}
				</div>

				<ExitModalForm isOpen={isModalOpen} onCloseModal={closeModal} />
				<OffertaPreview isOpen={isOpenOfferta} onCloseModal={closeOfferta} />
			</div>
		</header>
	)
}
export default Header
